     <div class="parent-wrapper" [ngClass]="bgClass">
         <div class="content-section">
            <h2 class="bg-content-title" [ngClass]="{'hideOnMobile': mobileTitle}">{{ title }}</h2>
            <h2 *ngIf="mobileTitle" class="bg-content-title-mobile">{{ mobileTitle }}</h2>
            <p class="bg-content-desc">{{ description }}</p>
            <button (click)="onButtonClick()" class="btn btn-primary mt-20">Get Started Now</button>
         </div>
     </div>
